import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";
import produce from "immer";
import log from "loglevel";

const createLab = (state = InitialState.labs, action) => {
  return produce(state, (draftState) => {
    const { labs } = draftState;
    labs.push(action.payload.lab);
    return draftState;
  });
};

const updateLab = (state = InitialState.labs, action) => {
  return produce(state, (draftState) => {
    const newlabs = draftState.labs.map((item) =>
      item.id === action.payload.lab.id ? action.payload.lab : item
    );
    draftState.labs = newlabs;
    return draftState;
  });
};

const deleteLab = (state = InitialState.labs, action) => {
  return produce(state, (draftState) => {
    log.log("this is draftstate of labs", draftState);
    const newlabs = draftState.labs.filter((item) => item.id !== action.payload);
    draftState.labs = newlabs;
    return draftState;
  });
};

const loadLabs = (state = InitialState.labs, action) => {
  return produce(state, (draftState) => {
    return action.payload;
  });
};
const createActivity = (state = InitialState.labs, action) => {
  return produce(state, (draftState) => {
    draftState.map((item, index) => {
      if (item.id === action.payload.labId) {
        //log.log("amanactivity",action.payload.activity);
        item.activity_set.push(action.payload.activity);
        //log.log("amanactivity",item.activity_set);
      }
      return item;
    });
    return draftState;
  });
};

const updateActivity = (state = InitialState.labs, action) => {
  return produce(state, (draftState) => {
    let lab = draftState.find((l) => l.id === action.payload.labId);
    const activityIndex = lab.activity_set.findIndex(
      (ac) => ac.id === action.payload.activity.id
    );
    lab.activity_set[activityIndex] = action.payload.activity;
  });
};

const deleteActivity = (state = InitialState.labs, action) => {
  return produce(state, (draftState) => {
    // Access the labs array from draftState
    const labs = draftState.labs;

    // Find the lab that matches the labId from the action payload
    const lab = labs.find((l) => l.id === action.payload.labId);
    
    if (lab) {
      // Ensure activity_set is initialized
      lab.activity_set = lab.activity_set || [];
      
      // Filter out the activity by id
      lab.activity_set = lab.activity_set.filter((act) => act.id !== action.payload.activityId);
    }
  });
};

export const LabsReducer = (state = InitialState.labs, action) => {
  //log.log("action", action, types)
  switch (action.type) {
    //   AUTH
    case types.LOAD_ALL_LABS:
      return loadLabs(state, action);

    case types.CREATE_LAB:
      return createLab(state, action);

    case types.UPDATE_LAB:
      return updateLab(state, action);

    case types.DELETE_LAB:
      return deleteLab(state, action);

    case types.CREATE_ACTIVITY:
      return createActivity(state, action);

    case types.UPDATE_ACTIVITY:
      return updateActivity(state, action);

    case types.DELETE_ACTIVITY:
      return deleteActivity(state, action);
  }
  return state;
};
